import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para rotas do sistema.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const ROTA = {
    MENU                  : { id: 'MENU',                  rota: "/tela-principal",        descricao: 'Menu Principal'                         },
    ADMIN                 : { id: 'ADMIN',                 rota: "/parametros-sistema",    descricao: 'Adminitração de parâmetros do sistema'  },
    CALENDARIO            : { id: 'CALENDARIO',            rota: "/calendario",            descricao: 'Calendário'                             },
    PRE_SESSAO            : { id: 'PRE_SESSAO',            rota: "/pre-sessao",            descricao: 'Pré-sessão'                             },
    SESSAO                : { id: 'SESSAO',                rota: "/sala-sessao",           descricao: 'Sessão'                                 },
    PAUTA                 : { id: 'PAUTA',                 rota: "/pauta-julgamento",      descricao: 'Pauta'                                  },
    ACOMPANHAMENTO_SESSAO : { id: 'ACOMPANHAMENTO_SESSAO', rota: "/acompanhamento-sessao", descricao: 'Acompanhamento de sessão de julgamento' },
    TELA_ERRO             : { id: 'TELA_ERRO',             rota: "/erro",                  descricao: 'Erro inesperado'                        },
    TELA_VERSAO           : { id: 'TELA_VERSAO',           rota: "/versao.html",           descricao: 'Versão build'                           }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de rotas do sistema.
 * @readonly
 */
class Rota {
    static situacaoBase = new SituacaoIdDescricaoBase(ROTA);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_VOTO = 'Não foi possível identificar a rota.';

    static getDescricao(id) {
        return Rota.situacaoBase.getDescricao(id);
    }

    static getRota(id) {
        return Rota.situacaoBase.getValorPropriedade(id, 'rota');
    }

    static getIdByRota(rota) {
        // Rota válida, porém não mapeada
        if (!rota || rota === '/') {
            return '';
        }

        let obj = Rota.situacaoBase.getObjectByProperty('rota', rota);

        if (!obj) {
            console.warn(`Rota "${rota}" desconhecida.`);
        }

        return obj ? Rota.getRota(obj.id) : '';
    }

    static getObjectByRota(rota) {
        return Rota.situacaoBase.getObjectByProperty('rota', rota);
    }
}

export default Rota;
